const appConfig = {
  // apiPrefix: " https://api-western.5techg.com/api ",
  // apiPrefix: " https://skybazar.vaishnaviprofile.com/api",
  // apiPrefix: " https://starbazar.5techg.com/api/v1/web",
  apiPrefix: "https://skymart-backend.onrender.com/api/v1/web",
  // apiPrefix: "https://skybazar.backend.5techg.com/api/v1/web",
  // apiPrefix: "https://skybazar-backend.onrender.com/api/v1/web",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
